import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import faq_img from "../../assests/img/faq.svg";

const FAQ = () => {
  return (
    <div className="faq">
      <div className="coustom_container">
        <Row className="faq_row">
          <Col lg={6} md={12}>
            <h1>FAQ</h1>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What is an MRI most commonly used for?
                </Accordion.Header>
                <Accordion.Body>
                  MRI is mainly used to produce images of organs, soft
                  tissues, and internal body structures. MRI scans provide
                  detailed images that distinguish normal from abnormal tissue
                  and are especially useful for visualizing the brain, spinal
                  cord, joints, and muscles. Because MRI does not use ionizing
                  radiation, it is safe and effective in the evaluation of soft
                  tissue pathology, injuries, and diseases.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Can ultrasound detect cancer?
                </Accordion.Header>
                <Accordion.Body>
                  Doctors can use an ultrasound to tell if a lump or tissue
                  abnormality requires more investigation. Ultrasound cannot
                  diagnose cancer alone, and because doctors find any
                  abnormality on ultrasound, doctors may require additional
                  tests such as a mammogram, MRI or biopsy.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>What is mammography?</Accordion.Header>
                <Accordion.Body>
                  Mammography is a breast imaging type. It uses low-dose X-rays
                  to detect breast cancer at an early stage. This often occurs
                  before women experience symptoms. Mammography can be used for
                  detection of lumps, calcium deposits or other signs of disease
                  in the breasts of people who do not have any symptoms.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Why would a person need to see a cardiologist?
                </Accordion.Header>
                <Accordion.Body>
                  A cardiologist (a medical specialist for diagnosing and
                  treating heart disease) should be consulted if someone is
                  experiencing chest pain, shortness of breath, arrhythmias, or
                  hypertension.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  Which is more accurate: CT scan or MRI?
                </Accordion.Header>
                <Accordion.Body>
                  Both are good, but each has strengths: CT quickly and clearly
                  shows bones and other areas of injury; MRI creates detailed
                  images of its soft tissue structures.
                </Accordion.Body>
              </Accordion.Item>
              {/* <Accordion.Item eventKey="6">
                <Accordion.Header>Lab Test At Home</Accordion.Header>
                <Accordion.Body>Agartala</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>Popular Tests</Accordion.Header>
                <Accordion.Body>Pregnancy Test</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>Lab Test At Home</Accordion.Header>
                <Accordion.Body>Agartala</Accordion.Body>
              </Accordion.Item> */}
            </Accordion>
          </Col>
          <Col lg={6} md={12}>
            <div className="faq_img">
              <img src={faq_img} alt="faq-img" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FAQ;
